import { InputHTMLAttributes, MouseEvent } from 'react';
import classes from './Input.module.css'


export const CheckBox = (props:InputHTMLAttributes<HTMLInputElement>) => {
    return ( 
            <input type="checkbox" {...props} />
        
    );
}